import React, { Component } from 'react';
import { Modal, Button } from "react-bootstrap";

import stopicon from '../../pages/img/icons/stop2-sm.png';
import goicon from '../../pages/img/icons/go2-sm.png';

import greenTrafficLight from '../../pages/img/indicators/traffic-lights-green.png';
import redTrafficLight from '../../pages/img/indicators/traffic-lights-red.png';

import quicktipIcon from '../../pages/img/icons/quicktips.jpg';

import IndicatorHeader from './IndicatorHeader';

class GRMIndicator extends Component { 
    
    constructor(props) {
        super(props);

        //alert(JSON.stringify(this.props.indicator));

        this.state = {
            isOpen: false,
			indicator: this.props.indicator
		};
        
     }


     expandCollapseOverview(event) {

        event.preventDefault();
  
        var overviewDiv = document.querySelector('#overviewSection'); 
  
        var overviewSign = document.querySelector('#overviewSign'); 
     
        if (overviewSign.innerHTML === "+")
        {
          overviewSign.innerHTML = "-";
          overviewDiv.style.display= "block";
        }else
        {
          overviewSign.innerHTML = "+";
          overviewDiv.style.display= "none";
        }
        
     }

  
     expandCollapseCalculations(event) {

        event.preventDefault();
  
        var calculationsDiv = document.querySelector('#calculationsSection'); 
  
        var calculationsSign = document.querySelector('#calculationsSign'); 
     
        if (calculationsSign.innerHTML === "+")
        {
            calculationsSign.innerHTML = "-";
            calculationsDiv.style.display= "block";
        }else
        {
            calculationsSign.innerHTML = "+";
            calculationsDiv.style.display= "none";
        }
        
     }


     componentDidUpdate() {
        
    }

    componentDidMount() {
        //alert(window.innerWidth);
    }

    componentWillUnmount() {
    }

    FormatIndicatorValue(valueType,value)
    {
        if (valueType == "PERCENT")
        {
            value = this.FormatPercent(value);

        } else if (valueType == "DOLLAR_AMOUNT")
        {
            value = this.FormatMoney(value);
        }
  

    return value;
   }

    
    FormatMoney(value)
  {
    let dollarUS = Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    });


    let formattedValue = dollarUS.format(value);

    if (formattedValue.endsWith(".00"))
    {
      formattedValue = formattedValue.substring(0, formattedValue.length-3);
    }
    //alert(formattedValue);

    return formattedValue;
  }



  FormatPercent(value)
  {
    value = value.toString() +"%";

    return value;
  }



   
    render() {

        return (

            <main>
            
               <div class="modal-body indicator-info-margins" style={{padding:"7px",margin:"0px"}}>
                   
                    <div style={{marginLeft:"5px",marginRight:"5px"}}>
         
                        <IndicatorHeader indicator={this.state.indicator}/>   

                        <div class="row" style={{paddingTop:'10px'}}>
                            <div class="col-md-12 indicator-info-indicator-result-text">
                                    {this.state.indicator?.indicatorValue >0 &&
                                    <div>
                                   {/* For every <b>$1</b> you put in you get about <b>{this.FormatMoney(this.state.indicator?.indicatorValue/100)}</b> back in return.   
                                   */}
                                    For every <b>$1,000</b> you put in you get about <b>{this.FormatMoney((this.state.indicator?.indicatorValue/100)*1000)}</b> back in return.
                                    </div>
                                    }     
                                     {this.state.indicator?.indicatorValue <0 &&
                                    <div>
                                        {/* 
                                    For every <b>$1</b> you put in you lose <b>{this.FormatMoney(Math.abs(this.state.indicator?.indicatorValue)/100)}</b>.   
                                    */}
                                    For every <b>$1,000</b> you put in you lose <b>{this.FormatMoney(Math.abs((this.state.indicator?.indicatorValue)/100)*1000)}</b>.   
                                    
                                    </div>
                                    }                   
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-12 indicator-info-indicator-expandable-title">
                            {this.state.indicator?.indicatorName} Overview  (<a href="#!" style={{textDecoration:"none"}}  onClick={(e) => this.expandCollapseOverview(e)}><span id="overviewSign" style={{fontSize:"23px"}}>+</span></a>)
                            </div>
                        </div>
                        <div class="row" id="overviewSection" style={{display:"none"}}>
                            <div class="col-md-12 indicator-info-indicator-result-text" style={{paddingTop:"10px"}}>
                                <div class="row">
                                    <div class="col-md-12">

                                        <div style={{paddingBottom:'12px'}}>
                                        The ROI is an indicator that answers the question, <b>"How much will I get back for each dollar I invest?"</b> 

                                        </div>

                                        <div style={{paddingBottom:'12px'}}>
                                        The ROI measures the financial return on an investment relative to its cost.
                                        </div>
                                        
                                        <div style={{paddingBottom:'12px'}}>
                                        ROI is calculated as the percentage difference between the current value (After Repair Value) of an investment and the original value (Purchase Price).
                                        </div>
                                        
                                        <div style={{paddingBottom:'12px'}}>
                                        ROI can be used to compare the returns on your real estate investment to investing your money in bonds and stocks.
                                        </div>
                                        
                                    </div>
                               </div>
                               <div class="row">
                                    <div class="col-md-12 indicator-info-indicator-sub-title">
                                    Benchmark
                                    </div>
                               </div>
                               <div class="row">
                                    <div class="col-md-12 indicator-info-indicator-result-text">
                                    <div style={{paddingBottom:'10px'}}>
                                    The higher the ROI, the better.  
                                    </div>

                                    <div style={{paddingBottom:'10px'}}>    
                                    The ROI on a property will be higher if you finance the property (get a mortgage) rather than buy it with your own cash. This is because the ROI calculates the return on your cash investment.
                                    </div>

                                    The less put of your own money, the better.
                                    
                                    <br></br><br></br>
                                    <span style={{fontWeight:"bold",color:"#777777"}}>
                                        You can adjust your <b>ROI</b> acceptance criteria in the settings based on your own investing goals and risk tolerance.
                                    </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12 indicator-info-indicator-expandable-title">
                                Calculations  (<a href="#!" style={{textDecoration:"none"}}  onClick={(e) => this.expandCollapseCalculations(e)}><span id="calculationsSign" style={{fontSize:"23px"}}>+</span></a>)
                            </div>
                        </div>
                    </div>   

                    <div class="row" id="calculationsSection" style={{marginTop:"15px",display:"none"}}>
                        
                        <div class="col-md-12">
                            <div class="row"> 
                            
                                    <div class="col-md-11 indicator-info-indicator-settings indicator-info-calculations-table">
                                        
                                        <div class="row">
                                            <div class="col-md-12" >
                                    
                                                <div class="row" style={{borderBottom:"2px solid  #1c7cfb",paddingBottom:"2px"}}>

                                                    <div class="col-md-7 indicator-info-indicator-accept indicator-info-calculations-table-col1">
                                                       Initial Investment        

                                                       {this.state.indicator.property.financingType == "Loan" &&        

                                                                <div style={{fontSize:"11px",fontWeight:"plain"}}>

                                                                    <table>
                                                                        {this.state.indicator.property.downPayment > 0 && 
                                                                            <tr>
                                                                                <td>Down Payment</td>
                                                                                <td style={{paddingLeft:'5px',paddingRight:'5px'}}>:</td>
                                                                                <td style={{textAlign:'right'}}>{this.FormatMoney(this.state.indicator.property.downPayment)}</td>
                                                                            </tr>
                                                                        }

                                                                        {this.state.indicator.property.closingCosts > 0 && 
                                                                            <tr>
                                                                                <td>Closing Costs</td>
                                                                                <td style={{paddingLeft:'5px',paddingRight:'5px'}}>:</td>
                                                                                <td style={{textAlign:'right'}}>{this.FormatMoney(this.state.indicator.property.closingCosts)}</td>
                                                                            </tr>
                                                                        }
                                                                        
                                                                            <tr>
                                                                                <td></td>
                                                                                <td></td>
                                                                                <td style={{borderTop:"2px solid  #1c7cfb",textAlign:'right',fontSize:'12px'}}><b>{this.state.indicator.helpVariableMap.VAR_INITAL_INVESTMENT}</b></td>
                                                                            </tr>

                                                                    </table>

                                                                    
                                                                </div>
                                                            }

                                                            {this.state.indicator.property.financingType == "Cash" &&        

                                                            <div style={{fontSize:"11px",fontWeight:"plain"}}>

                                                                <table>

                                                                    {this.state.indicator.property.price > 0 && 
                                                                        <tr>
                                                                            <td>Purchase Price</td>
                                                                            <td style={{paddingLeft:'5px',paddingRight:'5px'}}>:</td>
                                                                            <td style={{textAlign:'right'}}>{this.FormatMoney(this.state.indicator.property.price)}</td>
                                                                        </tr>
                                                                    }

                                                                    {this.state.indicator.property.closingCosts > 0 && 
                                                                        <tr>
                                                                            <td>Closing Costs</td>
                                                                            <td style={{paddingLeft:'5px',paddingRight:'5px'}}>:</td>
                                                                            <td style={{textAlign:'right'}}>{this.FormatMoney(this.state.indicator.property.closingCosts)}</td>
                                                                        </tr>
                                                                    }


                                                                
                                                                        <tr>
                                                                            <td></td>
                                                                            <td></td>
                                                                            <td style={{borderTop:"2px solid  #1c7cfb",textAlign:'right',fontSize:'12px'}}><b>{this.state.indicator.helpVariableMap.VAR_INITAL_INVESTMENT}</b></td>
                                                                        </tr>

                                                                </table>

                                                                
                                                            </div>
                                                            }
           
                                                    </div>
                                                    <div class="col-md-2 indicator-info-indicator-accept indicator-info-calculations-table-col2">
                                                        =>
                                                    </div>
                                                    <div class="col-md-3 indicator-info-indicator-settings-creteria indicator-info-calculations-table-col3">
                                                        {this.state.indicator.helpVariableMap.VAR_INITAL_INVESTMENT}
                                                    </div>

                                                </div>


                                                <div class="row" style={{borderBottom:"2px solid  #1c7cfb",paddingBottom:"2px"}}>

                                                    <div class="col-md-7 indicator-info-indicator-accept indicator-info-calculations-table-col1">
                                                        Rehab Costs         
                                                    </div>
                                                    <div class="col-md-2 indicator-info-indicator-accept indicator-info-calculations-table-col2">
                                                        =>
                                                    </div>
                                                    <div class="col-md-3 indicator-info-indicator-settings-creteria indicator-info-calculations-table-col3">
                                                        {this.state.indicator.helpVariableMap.VAR_REPAIRS}
                                                    </div>

                                                </div>

                                                <div class="row" style={{borderBottom:"2px solid  #1c7cfb",paddingBottom:"2px"}}>

                                                    <div class="col-md-7 indicator-info-indicator-accept indicator-info-calculations-table-col1">
                                                        Holding Costs         
                                                    </div>
                                                    <div class="col-md-2 indicator-info-indicator-accept indicator-info-calculations-table-col2">
                                                        =>
                                                    </div>
                                                    <div class="col-md-3 indicator-info-indicator-settings-creteria indicator-info-calculations-table-col3">
                                                        {this.state.indicator.helpVariableMap.VAR_HOLDING_COSTS}
                                                    </div>

                                                </div>
                                                <div class="row" style={{borderBottom:"2px solid  #1c7cfb",paddingBottom:"2px"}}>

                                                    <div class="col-md-7 indicator-info-indicator-accept indicator-info-calculations-table-col1">
                                                        Selling Costs         
                                                    </div>
                                                    <div class="col-md-2 indicator-info-indicator-accept indicator-info-calculations-table-col2">
                                                        =>
                                                    </div>
                                                    <div class="col-md-3 indicator-info-indicator-settings-creteria indicator-info-calculations-table-col3">
                                                        {this.state.indicator.helpVariableMap.VAR_SELLING_COSTS}
                                                    </div>

                                                </div>

                                                <div class="row" style={{borderBottom:"2px solid  #1c7cfb",paddingBottom:"2px"}}>

                                                    <div class="col-md-7 indicator-info-indicator-accept indicator-info-calculations-table-col1">
                                                        After Repair Value
                                                    </div>
                                                    <div class="col-md-2 indicator-info-indicator-accept indicator-info-calculations-table-col2">
                                                        =>
                                                    </div>
                                                    <div class="col-md-3 indicator-info-indicator-settings-creteria indicator-info-calculations-table-col3">
                                                        {this.state.indicator.helpVariableMap.VAR_AVR}
                                                    </div>

                                                </div>

                                                {this.state.indicator.property.financingType == "Loan" &&               
                                                <div class="row" style={{borderBottom:"2px solid  #1c7cfb",paddingBottom:"2px"}}>

                                                    <div class="col-md-7 indicator-info-indicator-accept indicator-info-calculations-table-col1">
                                                        Loan Amount
                                                    </div>
                                                    <div class="col-md-2 indicator-info-indicator-accept indicator-info-calculations-table-col2">
                                                        =>
                                                    </div>
                                                    <div class="col-md-3 indicator-info-indicator-settings-creteria indicator-info-calculations-table-col3">
                                                        {this.state.indicator.helpVariableMap.VAR_LOAN_AMOUNT}
                                                    </div>

                                                </div>
                                                }

                                                {this.state.indicator.property.financingType == "Loan" &&       
                                                <div class="row">

                                                    <div class="col-md-7 indicator-info-indicator-accept indicator-info-calculations-table-col1">
                                                        Monthly Mortgage Payment
                                                        {this.state.indicator.property.principalAndInterest == 0 && 
                                                        this.state.indicator.property.propertyTaxes == 0 && 
                                                        this.state.indicator.property.homeownersInsurance == 0 && 
                                                        this.state.indicator.property.hoa == 0 &&        

                                                            <div style={{fontSize:"11px",fontWeight:"plain"}}>Includes Principal & Interest, Taxes, Insurance and HOA.</div>
                                                        }

                                                        {(this.state.indicator.property.principalAndInterest > 0 || 
                                                        this.state.indicator.property.propertyTaxes > 0 ||
                                                        this.state.indicator.property.homeownersInsurance > 0 ||
                                                        this.state.indicator.property.hoa > 0) &&        

                                                            <div style={{fontSize:"11px",fontWeight:"plain"}}>

                                                                <table>
                                                                    {this.state.indicator.property.principalAndInterest > 0 && 
                                                                        <tr>
                                                                            <td>Principal & Interest</td>
                                                                            <td style={{paddingLeft:'5px',paddingRight:'5px'}}>:</td>
                                                                            <td style={{textAlign:'right'}}>{this.FormatMoney(this.state.indicator.property.principalAndInterest)}</td>
                                                                        </tr>
                                                                    }

                                                                    {this.state.indicator.property.propertyTaxes > 0 && 
                                                                        <tr>
                                                                            <td>Property Taxes</td>
                                                                            <td style={{paddingLeft:'5px',paddingRight:'5px'}}>:</td>
                                                                            <td style={{textAlign:'right'}}>{this.FormatMoney(this.state.indicator.property.propertyTaxes)}</td>
                                                                        </tr>
                                                                    }
                                                                    {this.state.indicator.property.homeownersInsurance > 0 && 
                                                                        <tr>
                                                                            <td>Homeowners Insurance</td>
                                                                            <td style={{paddingLeft:'5px',paddingRight:'5px'}}>:</td>
                                                                            <td style={{textAlign:'right'}}>{this.FormatMoney(this.state.indicator.property.homeownersInsurance)}</td>
                                                                        </tr>
                                                                    }
                                                                    {this.state.indicator.property.hoa > 0 && 
                                                                        <tr>
                                                                            <td>HOA</td>
                                                                            <td style={{paddingLeft:'5px',paddingRight:'5px'}}>:</td>
                                                                            <td style={{textAlign:'right'}}>{this.FormatMoney(this.state.indicator.property.hoa)}</td>
                                                                        </tr>
                                                                    }

                                                                        <tr>
                                                                            <td></td>
                                                                            <td></td>
                                                                            <td style={{borderTop:"2px solid  #1c7cfb",textAlign:'right',fontSize:'12px'}}><b>{this.state.indicator.helpVariableMap.VAR_MONTHLY_MORTGAGE}</b></td>
                                                                        </tr>

                                                                </table>

                                                                
                                                            </div>
                                                        }

                                                    </div>
                                                    <div class="col-md-2 indicator-info-indicator-accept indicator-info-calculations-table-col2">
                                                        =>
                                                    </div>
                                                    <div class="col-md-3 indicator-info-indicator-settings-creteria indicator-info-calculations-table-col3">
                                                        {this.state.indicator.helpVariableMap.VAR_MONTHLY_MORTGAGE}
                                                    </div>

                                                    </div>
                                                }

                                            </div>
                                        </div>
                                                             
                                    </div>
                            
                                    <div class="col-md-1">
                                        &nbsp;
                                    </div>
                                      
                             </div>

                            <div class="row">
                                    <div class="col-md-11" class="indicator-info-indicator-steps">
                                        
                                   
                                        {/* ---------------------  STEP 1 ------------------ */}
                                        
                                        <div class="row">
                                           
                                            <div class="col-md-12">
                                                <span class="indicator-info-indicator-step">STEP 1:</span> <b>Calculate Total Holding Costs</b>
                                            </div>
                                        </div>
                                        

                                       <div style={{paddingTop:'10px',paddingBottom:'10px',paddingLeft:'9%'}}>
                                            <div class="row">

                                                        Multiply the monthly holding costs by the number of <br></br>
                                                        months you will be holding the property.
                                                        <br></br><br></br>
                                                        <div class="col-md-5" style={{textAlign:"left",maxWidth:'250px'}}>
                                                            Monthly Holding Costs<span style={{float:'right'}}>=></span>
                                                        </div>

                                                        <div class="col-md-2" style={{paddingLeft:'0px',paddingRight:'0px',marginLeft:'0px',marginRight:'0px',width:'5px',maxWidth:'5px'}}>
                                                           
                                                        </div>
                                                        <div class="col-md-5" style={{textAlign:"right",maxWidth:'90px'}}>
                                                            <b>{this.state.indicator.helpVariableMap.VAR_MONTHLY_HOLDING_COSTS}</b>
                                                        </div>
                                            </div>
                                            
                                            <div class="row">
                                                        <div class="col-md-5" style={{textAlign:"left",maxWidth:'250px'}}>
                                                        Holding Months <span style={{float:'right'}}>=></span>
                                                        </div>
                                                        <div class="col-md-2" style={{paddingLeft:'0px',paddingRight:'0px',marginLeft:'0px',marginRight:'0px',width:'5px',maxWidth:'5px',textAlign:'right'}}>
                                                            x
                                                        </div>
                                                        <div class="col-md-5" style={{textAlign:"right",maxWidth:'90px'}}>
                                                            <b>{this.state.indicator.helpVariableMap.VAR_HOLDING_MONTHS}</b>
                                                        </div>
                                            </div>
                                            

                                            <div class="row">
                                                        <div class="col-md-5" style={{textAlign:"left",maxWidth:'250px'}}>
                                                            
                                                        </div>
                                                        <div class="col-md-2" style={{paddingLeft:'0px',paddingRight:'0px',marginLeft:'0px',marginRight:'0px',width:'5px',maxWidth:'5px',textAlign:'right'}}>
                                                            
                                                        </div>
                                                        <div class="col-md-5" style={{borderTop:"2px solid  #1c7cfb",textAlign:"right",maxWidth:'90px'}}>
                                                            <b>{this.state.indicator.helpVariableMap.VAR_HOLDING_COSTS}</b>
                                                        </div>
                                            </div>
                                   
                                        </div>

                                        <br></br>                
                                        
                                         {/* ---------------------  STEP 2 ------------------ */}
                                        
                                         {this.state.indicator.property.financingType == "Loan" &&  
                                        <div>        
                                         <div class="row">
                                           
                                           <div class="col-md-12">
                                               <span class="indicator-info-indicator-step">STEP 2:</span> <b>Calculate Total Mortgage Payments</b>
                                           </div>
                                         </div>
                                       

                                        <div style={{paddingTop:'10px',paddingBottom:'10px',paddingLeft:'9%'}}>
                                           <div class="row">
                                                        Multiply the monthly mortgage payment by the number of <br></br>
                                                        months you will be holding the property.
                                                        <br></br><br></br>


                                                       <div class="col-md-5" style={{textAlign:"left",maxWidth:'250px'}}>
                                                           Monthly Mortgage<span style={{float:'right'}}>=></span>
                                                       </div>

                                                       <div class="col-md-2" style={{paddingLeft:'0px',paddingRight:'0px',marginLeft:'0px',marginRight:'0px',width:'5px',maxWidth:'5px'}}>
                                                          
                                                       </div>
                                                       <div class="col-md-5" style={{textAlign:"right",maxWidth:'90px'}}>
                                                           <b>{this.state.indicator.helpVariableMap.VAR_MONTHLY_MORTGAGE}</b>
                                                       </div>
                                           </div>
                                           
                                           <div class="row">
                                                       <div class="col-md-5" style={{textAlign:"left",maxWidth:'250px'}}>
                                                       Holding Months <span style={{float:'right'}}>=></span>
                                                       </div>
                                                       <div class="col-md-2" style={{paddingLeft:'0px',paddingRight:'0px',marginLeft:'0px',marginRight:'0px',width:'5px',maxWidth:'5px',textAlign:'right'}}>
                                                           x
                                                       </div>
                                                       <div class="col-md-5" style={{textAlign:"right",maxWidth:'90px'}}>
                                                           <b>{this.state.indicator.helpVariableMap.VAR_HOLDING_MONTHS}</b>
                                                       </div>
                                           </div>
                                           

                                           <div class="row">
                                                       <div class="col-md-5" style={{textAlign:"left",maxWidth:'250px'}}>
                                                           
                                                       </div>
                                                       <div class="col-md-2" style={{paddingLeft:'0px',paddingRight:'0px',marginLeft:'0px',marginRight:'0px',width:'5px',maxWidth:'5px',textAlign:'right'}}>
                                                           
                                                       </div>
                                                       <div class="col-md-5" style={{borderTop:"2px solid  #1c7cfb",textAlign:"right",maxWidth:'90px'}}>
                                                           <b>{this.state.indicator.helpVariableMap.VAR_TOTAL_MORTGAGE_PAYMENTS}</b>
                                                       </div>
                                           </div>
                                  
                                        </div>

                
                                       <br></br>
                                       </div>
                                       }
                                       
                                        {/* ---------------------  STEP 3 ------------------ */}
                                        
                                        <div class="row">
                                           
                                            <div class="col-md-12">
                                                <span class="indicator-info-indicator-step">{this.state.indicator.property.financingType == "Loan" ? 'STEP 3' : 'STEP 2'}:</span> <b>Calculate Total Out of Pocket Investment</b>
                                            </div>
                                        </div>
                                        

                                       <div style={{paddingTop:'10px',paddingBottom:'10px',paddingLeft:'9%'}}>


                                            <div class="row">
   
                                                <div class="col-md-6" style={{textAlign:"left",maxWidth:'250px'}}>
                                                    Initial Investments<span style={{float:'right'}}>=></span>
                                                </div>

                                                <div class="col-md-2" style={{paddingLeft:'0px',paddingRight:'0px',marginLeft:'0px',marginRight:'0px',width:'5px',maxWidth:'5px'}}>
                                                    +
                                                </div>
                                                <div class="col-md-4" style={{textAlign:"right",maxWidth:'90px'}}>
                                                    <b>{this.state.indicator.helpVariableMap.VAR_INITAL_INVESTMENT}</b>
                                                </div>                                           
                                            </div>    

                                            <div class="row">
   
                                                <div class="col-md-6" style={{textAlign:"left",maxWidth:'250px'}}>
                                                {this.state.indicator.property.financingType == "Loan" && 
                                                    <span style={{fontSize:'11px',fontWeight:'bold'}}>(Down Payment + Closing Costs)</span>
                                                }
                                                {this.state.indicator.property.financingType == "Cash" && 
                                                    <span style={{fontSize:'11px',fontWeight:'bold'}}>(Purchase Price + Closing Costs)</span>
                                                }
                                                </div>
                                                   
                                              
                                            </div>  

  
                                            {this.state.indicator.property.financingType == "Loan" &&          
                                            <div class="row">
   
                                                <div class="col-md-6" style={{textAlign:"left",maxWidth:'250px'}}>
                                                    Mortgage Payments<span style={{float:'right'}}>=></span>
                                                </div>

                                                <div class="col-md-2" style={{paddingLeft:'0px',paddingRight:'0px',marginLeft:'0px',marginRight:'0px',width:'5px',maxWidth:'5px'}}>
                                                    +
                                                </div>
                                                <div class="col-md-4" style={{textAlign:"right",maxWidth:'90px'}}>
                                                    <b>{this.state.indicator.helpVariableMap.VAR_TOTAL_MORTGAGE_PAYMENTS}</b>
                                                </div>
                                            </div>
                                            }

                                            <div class="row">
                                            
                                                <div class="col-md-6" style={{textAlign:"left",maxWidth:'250px'}}>
                                                    Rehab Costs<span style={{float:'right'}}>=></span>
                                                </div>

                                                <div class="col-md-2" style={{paddingLeft:'0px',paddingRight:'0px',marginLeft:'0px',marginRight:'0px',width:'5px',maxWidth:'5px'}}>
                                                    +
                                                </div>
                                                <div class="col-md-4" style={{textAlign:"right",maxWidth:'90px'}}>
                                                    <b>{this.state.indicator.helpVariableMap.VAR_REPAIRS}</b>
                                                </div>
                                            </div>


                                            <div class="row">
                                                        <div class="col-md-6" style={{textAlign:"left",maxWidth:'250px'}}>
                                                        Holding Costs <span style={{float:'right'}}>=></span>
                                                        </div>
                                                        <div class="col-md-2" style={{paddingLeft:'0px',paddingRight:'0px',marginLeft:'0px',marginRight:'0px',width:'5px',maxWidth:'5px',textAlign:'right'}}>
                                                            +
                                                        </div>
                                                        <div class="col-md-4" style={{textAlign:"right",maxWidth:'90px'}}>
                                                            <b>{this.state.indicator.helpVariableMap.VAR_HOLDING_COSTS}</b>
                                                        </div>
                                            </div>
                                            

                                            <div class="row">
                                                        <div class="col-md-6" style={{textAlign:"left",maxWidth:'250px'}}>
                                                        Selling Costs <span style={{float:'right'}}>=></span>
                                                        </div>
                                                        <div class="col-md-2" style={{paddingLeft:'0px',paddingRight:'0px',marginLeft:'0px',marginRight:'0px',width:'5px',maxWidth:'5px',textAlign:'right'}}>
                                                            +
                                                        </div>
                                                        <div class="col-md-4" style={{textAlign:"right",maxWidth:'90px'}}>
                                                            <b>{this.state.indicator.helpVariableMap.VAR_SELLING_COSTS}</b>
                                                        </div>
                                            </div>
                                            
                                            <div class="row">
                                                        <div class="col-md-6" style={{textAlign:"left",maxWidth:'250px'}}>
                                                            
                                                        </div>
                                                        <div class="col-md-2" style={{paddingLeft:'0px',paddingRight:'0px',marginLeft:'0px',marginRight:'0px',width:'5px',maxWidth:'5px',textAlign:'right'}}>
                                                            
                                                        </div>
                                                        <div class="col-md-4" style={{borderTop:"2px solid  #1c7cfb",textAlign:"right",maxWidth:'90px'}}>
                                                            <b>{this.state.indicator.helpVariableMap.VAR_TOTAL_INVESTMENT}</b>
                                                        </div>
                                            </div>
                                   
                                        </div>
                                        
                                        <br></br>

                                         {/* ---------------------  STEP 4 ------------------ */}
                    
                                         <div class="row">
                                           
                                           <div class="col-md-12">
                                               <span class="indicator-info-indicator-step">{this.state.indicator.property.financingType == "Loan" ? 'STEP 4' : 'STEP 3'}:</span> <b>Calculate Profits</b>
                                           </div>
                                       </div>
                                       

                                      <div style={{paddingTop:'10px',paddingBottom:'10px',paddingLeft:'9%'}}>
                                           <div class="row">
                                                        Subtract the total out of pocket investment and the <br></br>
                                                        loan repayment (if financed) from the After Repair Value.

                                                        <br></br><br></br>


                                                       <div class="col-md-5" style={{textAlign:"left",maxWidth:'250px'}}>
                                                           After Repair Value<span style={{float:'right'}}>=></span>
                                                       </div>

                                                       <div class="col-md-2" style={{paddingLeft:'0px',paddingRight:'0px',marginLeft:'0px',marginRight:'0px',width:'5px',maxWidth:'5px'}}>
                                                          
                                                       </div>
                                                       <div class="col-md-5" style={{textAlign:"right",maxWidth:'90px'}}>
                                                           <b>{this.state.indicator.helpVariableMap.VAR_AVR}</b>
                                                       </div>
                                           </div>
                                           
                                           <div class="row">
                                                       <div class="col-md-5" style={{textAlign:"left",maxWidth:'250px'}}>
                                                       Total Investment <span style={{float:'right'}}>=></span>
                                                       </div>
                                                       <div class="col-md-2" style={{paddingLeft:'0px',paddingRight:'0px',marginLeft:'0px',marginRight:'0px',width:'5px',maxWidth:'5px',textAlign:'right'}}>
                                                           -
                                                       </div>
                                                       <div class="col-md-5" style={{textAlign:"right",maxWidth:'90px'}}>
                                                           <b>{this.state.indicator.helpVariableMap.VAR_TOTAL_INVESTMENT}</b>
                                                       </div>
                                           </div>

                                           {this.state.indicator.property.financingType == "Loan" &&       
                                           <div class="row">
                                                       <div class="col-md-5" style={{textAlign:"left",maxWidth:'250px'}}>
                                                       Loan Repayment <span style={{float:'right'}}>=></span>
                                                       </div>
                                                       <div class="col-md-2" style={{paddingLeft:'0px',paddingRight:'0px',marginLeft:'0px',marginRight:'0px',width:'5px',maxWidth:'5px',textAlign:'right'}}>
                                                           -
                                                       </div>
                                                       <div class="col-md-5" style={{textAlign:"right",maxWidth:'90px'}}>
                                                           <b>{this.state.indicator.helpVariableMap.VAR_LOAN_AMOUNT}</b>
                                                       </div>
                                           </div>
                                           }

                                           <div class="row">
                                                       <div class="col-md-5" style={{textAlign:"left",maxWidth:'250px'}}>
                                                           
                                                       </div>
                                                       <div class="col-md-2" style={{paddingLeft:'0px',paddingRight:'0px',marginLeft:'0px',marginRight:'0px',width:'5px',maxWidth:'5px',textAlign:'right'}}>
                                                           
                                                       </div>
                                                       <div class="col-md-5" style={{borderTop:"2px solid  #1c7cfb",textAlign:"right",maxWidth:'90px'}}>
                                                           <b>{this.state.indicator.helpVariableMap.VAR_PROFITS}</b>
                                                       </div>

                                                  
                                           </div>
                                           {this.state.indicator.property.financingType == "Loan" &&  
                                           <div>
                                                       <span style={{fontWeight:'bold'}}>Note:</span>
                                                      &nbsp;The loan repayment amount is a little less since <br></br>
                                                      you made monthly mortgage payments for {this.state.indicator.helpVariableMap.VAR_HOLDING_MONTHS} months, but <br></br>
                                                      since you mostly pay interest the first year that is a neglible <br>
                                                      </br>amount not worth deducting. 
                                            </div>
                                        }
                                       </div>

                
                                       <br></br>
                                       
                                            {/* ---------------------  STEP 5 ------------------ */}
                                          
                                        <div class="row">
                                           
                                            <div class="col-md-12">
                                                <span class="indicator-info-indicator-step">{this.state.indicator.property.financingType == "Loan" ? 'STEP 5' : 'STEP 4'}:</span> <b>Calculate ROI</b>
                                            </div>
                                        </div>
                                        
                                        
                                        <div class="row">
                                            <div class="col-md-12 indicator-info-formula-table">
                                                <div class="row" style={{paddingTop:"10px",paddingBottom:"10px",paddingLeft:'33%'}}>
                                                <table>
                                                        <tr>
                                                            <td style={{paddingTop:'5px'}}>ROI = </td>
                                                            <td style={{textAlign:"center",paddingLeft:'5px',paddingRight:'5px'}}>
                                                                <div style={{borderBottom: "2px solid  #1c7cfb", textAlign:'center',paddingLeft:'10px',paddingRight:'10px'}}>
                                                                     <b> 
                                                                       Profits
                                                                    </b>
                                                                </div>
                                                                 
                                                                <b>Total Investment</b>

                                                            </td>
                                                            <td> x 100</td>
                                                        </tr>

                                                    </table>

                                                </div>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-md-12 indicator-info-formula-table">
                                                <div class="row" style={{paddingTop:"10px",paddingBottom:"10px",paddingLeft:'33%'}}>
                                              
                                                    <div style={{paddingTop:'25px'}}>
                                                        <table>
                                                            <tr>
                                                                <td style={{paddingTop:'5px'}}>ROI = </td>
                                                                <td style={{textAlign:"center",paddingLeft:'5px',paddingRight:'5px'}}>
                                                                    <div style={{borderBottom: "2px solid  #1c7cfb", textAlign:'center',paddingLeft:'10px',paddingRight:'10px'}}><b>{this.state.indicator.helpVariableMap.VAR_PROFITS}</b></div>
                                                                    
                                                                    <b>{this.state.indicator.helpVariableMap.VAR_TOTAL_INVESTMENTS}</b>

                                                                </td>
                                                                <td> x 100</td>

                                                            </tr>

                                                        </table>
                                                    </div>

                                                   

                                                </div>
                                            </div>
                                        </div>
                                   
                                        <br></br>
                                  
                                        {/* ---------------------  STEP 5 ------------------ */}


                                        <div class="row">
                                            <div class="col-md-12">
                                                <span class="indicator-info-indicator-step">{this.state.indicator.property.financingType == "Loan" ? 'STEP 6' : 'STEP 5'}:</span> <b>Results</b>
                                            </div>
                                  </div>

                                        <div class="row">
                                            <div class="col-md-12 indicator-info-formula-table">
                                                <div class="row" style={{paddingTop:"10px",paddingBottom:"10px"}}>
                                                    <div class="col-md-5 indicator-info-formula-table-col1" style={{textAlign:'right'}}>
                                                    ROI = 
                                                    </div>
                                                    <div class="col-md-4 indicator-info-formula-table-col1">
                                                           <b>{this.FormatIndicatorValue(this.state.indicator?.valueType,this.state.indicator?.indicatorValue)}</b>
                                                    </div>
                                                  
                                                </div>
                                            </div>
                                  </div>
                                           
                                        <div class="row">
                                            <div class="col-md-11" style={{paddingTop:"15px",marginRight:"5px"}}>
                                            {this.state.indicator?.indicatorValue >0 &&
                                            <div>
                                            Which means that for every <b>$1</b> you put in you get about <b>{this.FormatMoney(this.state.indicator?.indicatorValue/100)}</b> back.   
                                            </div>
                                            }     
                                            {this.state.indicator?.indicatorValue <0 &&
                                            <div>
                                            Which means that for every <b>$1</b> you put in you lose <b>{this.FormatMoney(Math.abs(this.state.indicator?.indicatorValue)/100)}</b>.   
                                            </div>
                                            }   
                                            </div>
                                        </div>   

                                        <div class="row">
                                            <div class="col-md-10" style={{paddingTop:"15px",marginRight:"5px"}}>
                                                    This outcome can be changed by changing the ROI benchmark settings or by changing the following property values:
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-md-10" style={{textAlign:"left",fontWeight:"bold",paddingLeft:'25%',paddingTop:'10px'}}>
                                                
                                                {this.state.indicator.property.financingType == "Loan" &&  
                                                <span>
                                                LOAN AMOUNT<br></br>
                                                MONTHLY MORTGAGE PAYMENT<br></br>
                                                DOWN PAYMENT<br></br>
                                                </span>
                                                }
                                                {this.state.indicator.property.financingType == "Cash" &&  
                                                <span>
                                                PURCHASE PRICE<br></br>    
                                                </span>
                                                }
                                                PURCHASE CLOSING COSTS<br></br>
                                                REHAB COSTS<br></br>
                                                HOLDING COSTS<br></br>
                                                SELLING COSTS<br></br>
                                                AFTER REPAIR VALUE<br></br>
                                                
                                            </div>
                                  </div>

                                   
                                    </div>

                                    <div class="col-md-1">
                                        &nbsp;
                                    </div>  
                            </div>


                        </div>


                        
                    </div>      

                  {/* TIP */}
                  {this.state.indicator?.meetsBenchmark == false &&
                    
                    <div style={{paddingLeft:'5px',paddingTop:'10px'}}>   
                        
                        <img src={quicktipIcon} style={{height:'50px'}}/>  
                        <br></br>

                        If you want to turn this indicator green consider making any of the following changes:

                        <div style={{paddingTop:'10px',color:'#000000'}}>
                            <b>1)</b> Negotiate a lower <span style={{fontWeight:'600'}}>purchase price</span><br></br>
                            <b>2)</b> Lower your <span style={{fontWeight:'600'}}>closing costs</span><br></br>
                            <b>3)</b> Lower your <span style={{fontWeight:'600'}}>rehab costs</span><br></br>
                            <b>4)</b> Lower your <span style={{fontWeight:'600'}}>holding costs</span><br></br>
                            <b>5)</b> Lower your <span style={{fontWeight:'600'}}>selling costs</span><br></br> 
                            {this.state.indicator.property.financingType  == "Loan" &&         
                            <span>
                            <b>6)</b> Put down a larger <span style={{fontWeight:'600'}}>down payment</span><br></br>
                            </span>
                            }
                        </div>

                    </div>        
                }            

                {/* No Mortgage TIP */}
                {this.state.indicator?.property.financingType =="Cash" &&
                                                    
                    <div style={{paddingLeft:'5px',paddingTop:'10px'}}>   
                        
                        <img src={quicktipIcon} style={{height:'50px'}}/>  
                        <br></br>

                        <b>Note:</b> No mortgage has been specified for this property, therefore the initial investment is the entire purchase price; which means the property is not being financed. 
                        <br></br><br></br>
                        To get better results add a mortgage to finance part of the purchase price.

                    </div>        
                }       
                
                <br></br><br></br><br></br><br></br>
                </div>
                                                    
          
          </main> 
        );
    }
}

export default (GRMIndicator);
